module.exports = __webpack_public_path__ + "static/img/SI1.a00b80e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/SI1.jpg
// module id = k3ZH
// module chunks = 0